export default function Home() {
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-teal-50 to-blue-50 p-8 overflow-hidden">
      {/* Background Image - Single Large Landmark */}
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none">
        <img 
          src="https://public.readdy.ai/ai/img_res/0bd03fc0bbc9597568655cd1ad383c97.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      {/* Main Content */}
      <div className="relative z-10 text-center max-w-2xl">
        <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-teal-600 rounded-full shadow-lg">
          <i className="ri-plane-line text-4xl text-white"></i>
        </div>
        <h1 className="text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
          USA Travel Guide
        </h1>
        <p className="text-xl text-gray-700 mb-8 font-light">
          Hướng dẫn du lịch Mỹ toàn diện từ A-Z
        </p>
        <a 
          href="/visa-travel-tips"
          className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg text-base font-medium transition-all duration-200 hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
        >
          Xem Visa & Travel Tips
          <i className="ri-arrow-right-line text-lg"></i>
        </a>
      </div>
    </div>
  );
}